<template>
	<div>
		<c-header :discount="discount"></c-header>
		<c-main @discount-changed="changeDiscount"></c-main>
		<c-footer></c-footer>
	</div>
</template>

<script>
import CHeader from "./includes/Header"
import CFooter from "./includes/Footer"
import CMain from "./Main"

export default {
	components: {
		CHeader,
		CMain,
		CFooter,
	},
	data() {
		return {
			discount: 20,
		}
	},
	methods: {
		changeDiscount(newDiscount) {
			this.discount = newDiscount
		},
	},
}
</script>

<style lang="scss">
@import "../../assets/css/v1_fonts.css";
@import "../../assets/css/v1_main.css";
@import "../../assets/css/v1_res.css";
</style>
